import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import { types as loginTypes } from '../../auth/login';

import {
  BASE_INITIAL_STATE,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getSuccessListHandler,
  getFailureHandler,
} from '../../../store/structures';

const { Types, Creators } = createActions(
  {
    getRecommendedList: ['params'],
    ...PAGINATED_ACTIONS_SET,
  },
  { prefix: 'cb/businesses/recommended/' },
);

export { Types as types, Creators as actions };

export const HANDLERS = {
  [Types.REQUEST]: getRequestHandler(BASE_INITIAL_STATE),
  [Types.SUCCESS]: getSuccessListHandler(),
  [Types.SUCCESS_PAGINATED]: getSuccessListHandler({ attach: true }),
  [Types.FAILURE]: getFailureHandler(),
};

export default resettableReducer(loginTypes.LOGOUT)(createReducer(BASE_INITIAL_STATE, HANDLERS));
